/**
 * activity
 */
export default {
    name: 'pencilCase',
    path: '/pencil-case',
    meta: {},
    component: () => import('@/views/pencilCase/Home'),
    children: [
        {
            name: 'WrongQuestionBookList',
            path: 'wrong-question-book-list',
            meta: {},
            component: () => import('@/views/pencilCase/WrongQuestionBookList'),
        },
        {
            name: 'WrongQuestionBookDetail',
            path: 'wrong-question-book-detail',
            meta: {},
            component: () => import('@/views/pencilCase/WrongQuestionBookDetail'),
        },
        {
            name: 'WrongQuestionBookPromote',
            path: 'wrong-question-book-promote',
            meta: {},
            component: () => import('@/views/pencilCase/WrongQuestionBookPromote'),
        },
        {
            name: 'WrongQuestionBookShareDetail',
            path: 'wrong-question-book-share-detail',
            meta: {},
            component: () => import('@/views/pencilCase/WrongQuestionBookShareDetail'),
        },
    ],
};
